import { withStyles } from '@material-ui/core/styles';
import { LoginApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { useSelector } from 'react-redux';
import { appActions } from '@apply/adminStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOut } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';

export const Header = ({ children, notifyError }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const loginApi = new LoginApi.LoginApi(applicationInsights);

    const _handleLogout = async () => {
        appActions.setAppLoading(true, 'Logging out...');
        const _logout = await loginApi.logout();

        if (_logout) {
            appActions.setAppLoading(false);
            setTimeout(() => {
                window.location = window.location.origin + '/login';
            }, 1000);
        } else {
            appActions.setAppLoading(false);
            notifyError('Error logging you out');
            setTimeout(() => {
                window.location = window.location.origin + '/login';
            }, 1000);
        }
    };

    const _handleSettingsClick = () => {
        navigate('/settings');
    };

    const { firstName, lastName } = useSelector((state) => state.user);
    const userFullName = firstName && lastName ? `${firstName} ${lastName}` : '';
    const initials = firstName && lastName ? `${firstName[0]}${lastName[0]}`.toUpperCase() : '';

    if (location.pathname === '/' || location.pathname === '/login') {
        return <></>;
    }

    return (
        <header>
            {children}
            {/* eslint-disable-next-line */}
            <a
                href='#'
                className='logo'
            >
                <img
                    src='/images/header-logo.png'
                    alt='Builder Finance'
                />
            </a>
            <div className='site-name'>Loan Administration</div>
            <div className='user'>
                <span
                    className='user-name'
                    onClick={_handleSettingsClick}
                    style={{ cursor: 'pointer' }}
                >
                    {userFullName}
                </span>
                <div
                    className='avatar'
                    onClick={_handleSettingsClick}
                    style={{ cursor: 'pointer' }}
                >
                    <span>{initials}</span>
                </div>

                <span
                    onClick={_handleLogout}
                    title='Logout'
                    style={{ cursor: 'pointer' }}
                >
                    <FontAwesomeIcon icon={faSignOut} />
                </span>
            </div>
        </header>
    );
};

const drawerWidth = 240;

const styles = (theme) => ({
    root: {
        display: 'flex',
        height: '100vh',
    },

    content: {
        flexGrow: 1,
        // padding: theme.spacing.unit * 3,
        height: '100%',
        overflow: 'scroll',
        [theme.breakpoints.down('sx')]: {
            content: '',
        },
    },
    mobileContent: {
        padding: '85px 0px 20px 0px',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.down('xs')]: {
            width: 0,
        },
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    headerLogo: {
        height: 12,
        marginRight: 'auto',
    },
    headerMenu: {
        marginRight: '20px',
    },
    notificationMenu: {
        width: '100px',
    },
    notificationItem: {
        fontSize: '12px',
    },
});

export default withStyles(styles)(Header);
